<template>
  <form
    :class="[$style.root, type === 'primary' && $style.isPrimary]"
    @submit.prevent="submit"
  >
    <el-input
      :class="$style.input"
      :placeholder="placeholder"
      :value="value"
      clearable
      @input="
        value => {
          $emit('input', value)
        }
      "
      @clear="
        () => {
          $emit('input', '')
          $emit('submit')
        }
      "
    >
      <el-button
        slot="append"
        icon="el-icon-search"
        native-type="submit"
      ></el-button>
    </el-input>
  </form>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    type: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    }
  },

  methods: {
    submit() {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="scss" module>
.input {
  :global(.el-input__inner) {
    height: 3.5rem;
    line-height: 3.5rem;
  }

  :global(.el-input-group__append) {
    background-color: #02b0e1;
    color: #ffffff;
    font-size: 1.25rem;

    .root.isPrimary & {
      background-color: #d0021b;
    }
  }

  .root.isPrimary & {
    font-size: 1.125rem;
  }
}
</style>
